import {CSSProperties, useContext} from "react";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {GameContext} from "@components/game/GameProvider";
import {WorkerClient} from "@host/services/workerClient";
import {THEME} from "@components/core/theme";

const WORKER_URL = (import.meta.env.VITE_WORKER_URL as string | undefined) ?? "http://localhost:8787";

const styles: Record<string, CSSProperties> = {
    ...THEME,
    googleButton: {
        alignItems: "center",
        display: "flex",
        gap: 8,
        justifyContent: "center"
    },
    googleIcon: {
        height: 18,
        width: 18
    }
};

const isInIframe = window.self !== window.top;

export function GoogleSignIn() {
    const game = useContext(GameContext);

    const handleClick = () => {
        const client = WorkerClient.instance;
        const params = new URLSearchParams();

        if (client.isAnonymous && client.userId) {
            params.set("anonymousUserId", client.userId);
        }

        if (isInIframe) {
            params.set("popup", "1");
            const url = `${WORKER_URL}/auth/google/initiate?${params.toString()}`;
            const popup = window.open(url, "googleAuth", "width=520,height=620,left=200,top=100");

            const handleMessage = (event: MessageEvent) => {
                if (!event.data || event.data.type !== "google-auth") return;
                window.removeEventListener("message", handleMessage);

                if (event.data.google === "ok") {
                    WorkerClient.instance.storeTokens({
                        accessToken:  event.data.accessToken,
                        refreshToken: event.data.refreshToken,
                        userId:       event.data.userId,
                        isAnonymous:  event.data.isAnonymous === "true",
                        email:        event.data.email ?? null
                    });
                    window.location.reload();
                }

                popup?.close();
            };

            window.addEventListener("message", handleMessage);
        } else {
            const query = params.toString();
            window.location.href = `${WORKER_URL}/auth/google/initiate${query ? `?${query}` : ""}`;
        }
    };

    return (
        <button onClick={handleClick} style={styles.button}>
            <div style={styles.googleButton}>
                <img alt="" src="/images/icons/google.svg" style={styles.googleIcon}/>
                <LocalisedTypography content="AuthenticationGoogleSignIn"/>
            </div>
        </button>
    );
}
